<template>
  <MainContent>
      <div>
        <b-card no-body>
          <nx-bform>
            <h5>{{$t('activationKey')}}</h5>
            <b-input-group>
              <b-form-input
                v-model="activationKey"
                :placeholder="$t('activationKeyPlaceholder')"
              />
            </b-input-group>

            <b-form-group class="mt-2 justify-content-end">
              <b-button
                class="bd-button mr-2"
                @click="redirect(activationKey)"
                >{{$t('confirm')}}</b-button
              >
              <b-button variant="danger" @click="back"
                >{{$t('back')}}</b-button
              >
            </b-form-group>
          </nx-bform>
        </b-card>
      </div>
  </MainContent>
</template>
<script>
import MainContent from "../../../components/main/MainContent";
export default {
  data() {
    return {
      activationKey: null,
    };
  },
  methods: {
    back() {
      this.$router.push({
        name: "Login",
      });
    },    
    redirect(activationKey){
      console.log("activationKey", activationKey);
      if(!activationKey){
        this.$dangerToast(this.$t("error"), this.$t("activationKeyPlaceholder"));
        return;
      }
      window.location.href = "/public/bd/#/set-password?activation-key=" + activationKey + "&newUser=true&targetUrl=%2Fpublic%2Fbd%2F%23%2Flogin";
    }
  },
};
</script>
<style>
.green-text {
  color: #2b7366;
}

.header {
  background-color: #2b7366;
  color: white;
  font-size: 24px;
}

.info-header {
  text-align: center;
  background-color: #005d99;
  /*margin: auto;*/
}
.info-btn {
  text-align: center;
  margin-bottom: 30px;
}
.info-btn button {
  color: #fff;
  font-weight: 800;
  padding: 8px;
  border-radius: 0.25rem;
  background-color: #2b7366;
  border: none;
}
</style>

<i18n src="@/locales/login.locale"></i18n>
<i18n src="@/locales/actions.locale"></i18n>
<i18n src="@/locales/msg.locale"></i18n>